export interface ArticleContent {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  views: number;
  image: string;
  excerpt: string;
  hot: boolean;
  tags: string[];
  sections: {
    type: 'heading' | 'paragraph' | 'quote' | 'image' | 'list';
    content?: string;
    items?: string[];
    image?: string;
    imageAlt?: string;
  }[];
}

export const articles: Record<string, ArticleContent> = {
  'tech-data-leak-2026': {
    id: 1,
    title: '深度揭秘：某知名互联网企业数据泄露内幕，数千万用户信息被非法交易',
    slug: 'tech-data-leak-2026',
    category: '内幕揭秘',
    categorySlug: 'insider-reveal',
    author: '51黑料网调查组',
    date: '2026-06-28',
    views: 128500,
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20investigative%20scene%20with%20silhouetted%20figure%20holding%20documents%20against%20dim%20urban%20night%20background%2C%20moody%20cinematic%20lighting%20with%20deep%20shadows%20and%20warm%20amber%20accents%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20low%20key%20photography%2C%20corporate%20intrigue%20theme&width=1600&height=900&seq=article-detail-01&orientation=landscape',
    excerpt: '经过长达三个月的深入调查，我们发现某头部互联网公司存在严重的数据安全漏洞，导致超过3000万用户的个人信息在黑市上被公开叫卖。',
    hot: true,
    tags: ['数据泄露', '互联网企业', '用户隐私', '信息安全'],
    sections: [
      {
        type: 'heading',
        content: '三个月暗访：揭开数据黑市冰山一角',
      },
      {
        type: 'paragraph',
        content: '2026年初，51黑料网调查组接到多名内部人士爆料，称某知名互联网企业存在大规模用户数据泄露问题。经过长达三个月的深入调查与暗访，我们获得了一份令人生畏的数据交易记录——超过3000万用户的个人信息，包括真实姓名、手机号码、身份证号、家庭住址等敏感数据，正在多个地下数据交易平台上被明码标价，公开叫卖。',
      },
      {
        type: 'image',
        image: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20blinking%20lights%20and%20cables%2C%20dramatic%20low%20key%20lighting%2C%20cybersecurity%20breach%20theme%2C%20cinematic%20noir%20atmosphere%2C%20deep%20charcoal%20tones%20with%20amber%20warning%20lights&width=1200&height=675&seq=article-img-1a&orientation=landscape',
        imageAlt: '暗访拍摄的数据交易现场',
      },
      {
        type: 'heading',
        content: '数据泄露规模触目惊心',
      },
      {
        type: 'paragraph',
        content: '根据调查组获取的内部数据库快照，此次泄露涉及的数据字段包括：用户真实姓名、注册手机号、身份证号码（部分为实名认证用户）、详细家庭住址、银行卡绑定信息（脱敏后的后四位）、以及近三年的消费行为轨迹。尤其值得注意的是，这些数据中包含了大量2023年至2025年间新注册用户的信息，表明泄露并非一次性的历史事件，而是持续发生的安全漏洞。',
      },
      {
        type: 'paragraph',
        content: '我们通过技术手段追踪到，这些数据的首次流出时间可以追溯到2025年第三季度。然而，该企业在对外公告中从未提及此次数据泄露事件，甚至在2025年底发布的年度安全报告中还宣称其"用户数据保护体系完好无损"。',
      },
      {
        type: 'quote',
        content: '最令人不安的是，这些数据在地下市场的售价极低——一条包含完整身份信息的用户数据仅售0.5元至2元不等。这意味着任何一个有恶意意图的人都可以轻松获取海量用户隐私。',
      },
      {
        type: 'heading',
        content: '企业回应：避重就轻的公关话术',
      },
      {
        type: 'paragraph',
        content: '在调查组获得充分证据后，我们于6月25日向该企业发送了采访函。企业公关部门在24小时内给出了回复，但回复内容令人失望——全文充斥着"我们高度重视用户数据安全""正在进行内部核查"等套话，对具体的数据泄露事实避而不谈，也未就受影响用户数量给出任何明确数字。',
      },
      {
        type: 'paragraph',
        content: '更加值得警惕的是，在我们的报道即将发布之际，该企业委托的律师事务所向我们发来了措辞强硬的律师函，试图以"商业诽谤"为由阻止报道发布。51黑料网坚持新闻真实的立场，我们有充分证据证明报道内容的真实性。',
      },
      {
        type: 'heading',
        content: '监管介入：网信办已启动调查程序',
      },
      {
        type: 'paragraph',
        content: '据知情人士透露，国家互联网信息办公室已注意到此事，并已向涉事企业发出问询函。同时，公安部网络安全保卫局也已介入调查数据泄露的具体源头和责任认定。',
      },
      {
        type: 'paragraph',
        content: '根据《中华人民共和国个人信息保护法》第六十六条规定，情节严重的个人信息泄露事件，企业可能面临"五千万元以下或者上一年度营业额百分之五以下"的巨额罚款，相关责任人还可能承担刑事责任。',
      },
      {
        type: 'heading',
        content: '用户应该如何保护自己',
      },
      {
        type: 'list',
        items: [
          '立即修改该平台账号的登录密码，并开启两步验证',
          '关注银行账户异常交易，如发现可疑交易立即联系银行',
          '警惕以该平台名义发送的钓鱼短信和诈骗电话',
          '通过官方渠道查询自己的个人信息是否已被泄露',
          '如确认信息已被泄露，可向当地网信部门投诉举报',
        ],
      },
      {
        type: 'paragraph',
        content: '51黑料网将持续关注此事件的进展，并呼吁有关部门依法严肃处理此次数据泄露事件，切实保护广大用户的个人信息安全。我们将继续追踪报道，敬请关注后续更新。',
      },
    ],
  },

  'entertainment-capital-scandal': {
    id: 2,
    title: '娱乐圈惊天丑闻：顶流艺人背后资本运作链曝光，涉及金额超十亿',
    slug: 'entertainment-capital-scandal',
    category: '丑闻曝光',
    categorySlug: 'scandal-expose',
    author: '51黑料网文娱调查组',
    date: '2026-06-27',
    views: 96200,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20backstage%20scene%20with%20spotlight%20and%20long%20shadows%20on%20empty%20stage%2C%20dramatic%20noir%20lighting%2C%20theatrical%20atmosphere%20with%20crimson%20and%20charcoal%20tones%2C%20cinematic%20composition%2C%20entertainment%20industry%20expose%20theme&width=1600&height=900&seq=article-detail-02&orientation=landscape',
    excerpt: '一份内部财务文档揭示了某顶流艺人背后的复杂资本运作网络，涉及多家空壳公司、洗钱嫌疑以及偷税漏税行为。',
    hot: true,
    tags: ['娱乐圈', '资本运作', '偷税漏税', '洗钱'],
    sections: [
      {
        type: 'heading',
        content: '一份神秘文档引发的连锁反应',
      },
      {
        type: 'paragraph',
        content: '2026年5月，一位不愿透露姓名的知情人士向51黑料网提供了一份标注为"机密"的内部财务文档。该文档详细记录了某位拥有超过5000万粉丝的顶流艺人（以下简称"艺人X"）的资本运作网络——一个由12家空壳公司、3家境外离岸公司和4家境内投资公司组成的复杂商业结构，涉及金额初步估计超过十亿元人民币。',
      },
      {
        type: 'image',
        image: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20office%20with%20scattered%20financial%20documents%20under%20dim%20spotlight%2C%20moody%20cinematic%20atmosphere%2C%20corporate%20investigation%20theme%2C%20deep%20charcoal%20and%20crimson%20tones&width=1200&height=675&seq=article-img-2a&orientation=landscape',
        imageAlt: '内部财务文档部分内容',
      },
      {
        type: 'heading',
        content: '12家空壳公司的运作模式',
      },
      {
        type: 'paragraph',
        content: '根据文档记录，这12家空壳公司分别注册于不同的城市和地区，注册信息中均未出现艺人X的真实姓名。然而，通过追踪公司之间的资金流向和股权穿透，调查组发现这些公司之间存在明显的关联交易和资金闭环特征。',
      },
      {
        type: 'paragraph',
        content: '典型的运作模式是：品牌方支付的广告代言费用首先进入其中一家表面上的"经纪公司"，然后通过各种名目的"服务费""咨询费""版权费"等，将资金层层转移到多个关联公司，最终汇入境外的离岸账户。通过这种方式，原本应当缴纳个人所得税的劳务报酬被"转化"为企业间交易，大幅降低了纳税基数。',
      },
      {
        type: 'quote',
        content: '仅2024年度，通过这套"资金转移体系"流转的金额就超过了2.8亿元。按照正常的个人所得税累进税率计算，仅此一年可能涉及的逃税金额就高达上亿元。',
      },
      {
        type: 'heading',
        content: '境外离岸公司的隐秘角色',
      },
      {
        type: 'paragraph',
        content: '文档中还揭示了3家境外离岸公司的存在，分别注册在开曼群岛和英属维尔京群岛。这些离岸公司的主要功能有两个：一是接收从境内转移出来的资金，二是通过复杂的跨境交易将资金"漂白"后重新回流国内，用于购买豪宅、游艇等奢侈品。',
      },
      {
        type: 'paragraph',
        content: '值得关注的是，这种资金跨境流动的模式已经引起了外汇管理部门的注意。知情人士透露，国家外汇管理局已针对此类资金异常流动展开了专项排查。',
      },
      {
        type: 'heading',
        content: '行业乱象：并非个例',
      },
      {
        type: 'paragraph',
        content: '实际上，艺人X的案例并非娱乐圈的孤例。近年来，随着国家对文娱行业的监管力度不断加大，已有多位知名艺人因税务问题被查处。然而，仍有部分艺人和其背后的团队试图通过更加隐蔽和复杂的方式来规避法律监管。',
      },
      {
        type: 'paragraph',
        content: '51黑料网了解到，税务部门已经掌握了一批类似案例的线索，预计将在未来几个月内陆续公布调查结果。这次曝光只是整个行业整顿的序幕。',
      },
      {
        type: 'heading',
        content: '法律后果分析',
      },
      {
        type: 'paragraph',
        content: '根据《中华人民共和国税收征收管理法》和《刑法》相关规定，以欺骗、隐瞒手段进行虚假纳税申报或者不申报，逃避缴纳税款数额较大并且占应纳税额百分之十以上的，处三年以下有期徒刑或者拘役，并处罚金；数额巨大并且占应纳税额百分之三十以上的，处三年以上七年以下有期徒刑，并处罚金。',
      },
      {
        type: 'paragraph',
        content: '考虑到本案涉及金额巨大、手法隐蔽、持续时间长等特点，如果调查结果与文档记录相符，相关人员可能面临严厉的法律制裁。51黑料网将持续跟踪此案的后续进展。',
      },
    ],
  },

  'food-safety-scandal': {
    id: 3,
    title: '食品安全黑幕：多家知名连锁餐饮使用过期变质食材，后厨画面触目惊心',
    slug: 'food-safety-scandal',
    category: '独家黑料',
    categorySlug: 'exclusive',
    author: '51黑料网食品安全调查组',
    date: '2026-06-26',
    views: 154300,
    image: 'https://readdy.ai/api/search-image?query=Dark%20gritty%20industrial%20kitchen%20scene%20with%20dim%20overhead%20lighting%2C%20stainless%20steel%20surfaces%20with%20deep%20shadows%2C%20moody%20atmospheric%20tone%2C%20investigative%20documentary%20style%2C%20warm%20amber%20highlights%20on%20dark%20charcoal%20background&width=1600&height=900&seq=article-detail-03&orientation=landscape',
    excerpt: '暗访记者潜入多家网红连锁餐厅后厨，拍下了令人震惊的画面——发霉的原料、重复使用的回收油、蟑螂横行的操作间。',
    hot: true,
    tags: ['食品安全', '连锁餐饮', '过期食材', '卫生问题'],
    sections: [
      {
        type: 'heading',
        content: '暗访行动：记者卧底后厨三周',
      },
      {
        type: 'paragraph',
        content: '2026年5月至6月，51黑料网食品安全调查组的暗访记者以求职者的身份，先后进入三家在全国拥有超过100家门店的知名连锁餐饮品牌，进行了为期三周的卧底调查。我们所拍摄到的后厨画面，足以让每一位消费者感到愤怒和不安。',
      },
      {
        type: 'image',
        image: 'https://readdy.ai/api/search-image?query=Dark%20dirty%20commercial%20kitchen%20interior%20with%20grimy%20surfaces%2C%20dim%20fluorescent%20lighting%2C%20food%20safety%20violation%20theme%2C%20documentary%20style%2C%20deep%20charcoal%20and%20muted%20amber%20tones&width=1200&height=675&seq=article-img-3a&orientation=landscape',
        imageAlt: '暗访记者拍摄的后厨实况',
      },
      {
        type: 'heading',
        content: '触目惊心的五大问题',
      },
      {
        type: 'paragraph',
        content: '经过整理，调查组将此次暗访发现的问题归纳为以下五大类，每一个都严重违反了《食品安全法》的相关规定：',
      },
      {
        type: 'list',
        items: [
          '过期食材翻新使用：已经过期3-5天的肉类和蔬菜，经过重新清洗、腌制后继续端上餐桌',
          '回收油反复使用：炸制食品的食用油连续使用超过一周，颜色已呈深黑色且散发刺鼻气味',
          '后厨卫生触目惊心：蟑螂、老鼠痕迹频繁出现，操作台从未按规定消毒',
          '标签日期随意篡改：预包装食材的保质期标签被人为撕毁或涂改',
          '员工健康证缺失：多名后厨工作人员未持有有效的健康证明',
        ],
      },
      {
        type: 'quote',
        content: '一位在后厨工作了两年的老员工私下告诉记者："这些东西我们自己从来不吃。每天下班后我们都会去隔壁的小店吃饭，因为知道这里的东西不干净。"',
      },
      {
        type: 'heading',
        content: '监管漏洞为何长期存在',
      },
      {
        type: 'paragraph',
        content: '调查组发现，这三家连锁品牌均通过了当地的食品安全检查，并在门店显著位置悬挂了"食品安全等级A级"的公示牌。那么，为何实际上后厨情况与评级严重不符？',
      },
      {
        type: 'paragraph',
        content: '据了解，部分地区的食品监管部门存在检查前提前通知的现象，使得餐饮企业有充足时间进行"表面整改"。此外，第三方检测机构的抽检频率过低，无法形成有效的日常监督。更深层次的原因在于，加盟模式下总部对门店的管理松散，而违规成本相对较低。',
      },
      {
        type: 'heading',
        content: '企业回应与后续进展',
      },
      {
        type: 'paragraph',
        content: '报道发布前，51黑料网已向三家涉事企业的总部发送了详细的调查函。其中两家企业表示将"立即开展内部调查"，一家企业则选择否认所有指控。',
      },
      {
        type: 'paragraph',
        content: '目前，涉及的三个城市市场监督管理部门已经组成联合调查组，对涉事门店进行了突击检查。初步检查结果与我们的暗访发现基本吻合，相关门店已被责令停业整顿。',
      },
      {
        type: 'paragraph',
        content: '51黑料网将继续跟踪此事件的后续处理结果，并呼吁消费者在就餐过程中保留维权意识，遇到食品安全问题及时拨打12315投诉举报。',
      },
    ],
  },

  'investment-insider-trading': {
    id: 4,
    title: '某知名投资机构合伙人被曝涉嫌内幕交易，证监会已介入调查',
    slug: 'investment-insider-trading',
    category: '财经黑幕',
    categorySlug: 'finance',
    author: '51黑料网财经调查组',
    date: '2026-06-28',
    views: 198300,
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20abstract%20with%20scattered%20documents%20in%20dramatic%20low%20light%2C%20moody%20cinematic%20noir%20lighting%2C%20financial%20investigation%20theme%2C%20deep%20charcoal%20tones%20with%20amber%20accents&width=1200&height=675&seq=article-detail-04&orientation=landscape',
    excerpt: '知情人士透露，该合伙人在多起重大并购案公布前进行异常交易，获利超过5000万元。目前证监会已正式立案。',
    hot: true,
    tags: ['内幕交易', '证监会', '投资机构', '并购'],
    sections: [
      {
        type: 'heading',
        content: '异常交易记录浮出水面',
      },
      {
        type: 'paragraph',
        content: '2026年6月，中国证监会在对2025年第四季度至2026年第一季度的异常交易数据进行大数据筛查时，发现了一组高度可疑的交易记录。这些记录指向某知名投资机构的合伙人（以下简称"合伙人Y"），其在多起重大并购案正式公布前，精准地进行了大量相关股票的交易操作。',
      },
      {
        type: 'paragraph',
        content: '根据51黑料网获得的交易数据分析，合伙人Y在2025年10月至2026年3月期间，共涉及6起重大资产重组和并购项目。在每一项目正式公告前的3至10个工作日内，其控制的多个账户均出现了大额买入目标公司股票的行为。6起交易的累计获利超过5000万元，投资回报率高达惊人的340%。',
      },
      {
        type: 'heading',
        content: '内幕信息获取渠道分析',
      },
      {
        type: 'paragraph',
        content: '调查组深入分析后发现，这6起并购案中有5起的财务顾问正是合伙人Y所在的投资机构。作为机构的合伙人，Y拥有接触并购交易核心信息的权限和机会。这种"既是裁判员又是运动员"的双重身份，为其获取内幕信息并实施交易提供了便利条件。',
      },
      {
        type: 'paragraph',
        content: '更加值得关注的是，交易记录显示，部分买入操作使用了Y亲属和关联人士的账户，这种做法明显是为了规避监管部门的日常监控。然而，在大数据筛查技术面前，这些看似"隐蔽"的操作最终还是露出了马脚。',
      },
      {
        type: 'heading',
        content: '法律分析',
      },
      {
        type: 'paragraph',
        content: '根据《中华人民共和国证券法》第一百九十一条规定，证券交易内幕信息的知情人或者非法获取内幕信息的人，在涉及证券的发行、交易或者其他对证券的价格有重大影响的信息公开前，买卖该证券，或者泄露该信息，或者建议他人买卖该证券的，责令依法处理非法持有的证券，没收违法所得，并处以违法所得一倍以上五倍以下的罚款。',
      },
      {
        type: 'paragraph',
        content: '考虑到本案涉及金额巨大且时间跨度较长，根据《刑法》第一百八十条关于内幕交易罪的规定，相关人员可能面临五年以上十年以下有期徒刑，并处违法所得一倍以上五倍以下罚金。',
      },
      {
        type: 'heading',
        content: '证监会回应',
      },
      {
        type: 'paragraph',
        content: '证监会新闻发言人在例行发布会上回应称："我们注意到相关报道，目前已按程序对相关线索展开调查。证监会坚决贯彻落实零容忍方针，对资本市场违法违规行为发现一起、查处一起，绝不姑息。"',
      },
    ],
  },

  'real-estate-crisis': {
    id: 5,
    title: '房地产行业大洗牌：前20强房企中已有5家资金链断裂',
    slug: 'real-estate-crisis',
    category: '内幕揭秘',
    categorySlug: 'insider-reveal',
    author: '51黑料网财经调查组',
    date: '2026-06-27',
    views: 167400,
    image: 'https://readdy.ai/api/search-image?query=Dark%20construction%20site%20silhouette%20with%20crane%20against%20moody%20sky%2C%20dramatic%20cinematic%20lighting%2C%20real%20estate%20theme%2C%20deep%20charcoal%20tones%20with%20subtle%20crimson%20highlights&width=1200&height=675&seq=article-detail-05&orientation=landscape',
    excerpt: '据内部人士提供的银行流水和财务报表显示，多家头部房企已无法偿还到期债务，涉及金额超过千亿规模。',
    hot: true,
    tags: ['房地产', '资金链', '债务危机', '行业洗牌'],
    sections: [
      {
        type: 'heading',
        content: '内部文件揭示的严峻现实',
      },
      {
        type: 'paragraph',
        content: '2026年第二季度，房地产行业的寒意进一步加剧。51黑料网从多个独立渠道获得了一组令人震惊的数据：在2025年销售额排名前20的房地产企业中，已有5家出现了严重的流动性危机，无法按时偿还到期债务。涉及的总债务规模超过1200亿元。',
      },
      {
        type: 'paragraph',
        content: '这5家企业中，有3家是民营企业，2家为混合所有制企业。它们的共同特征是：在过去三年中采取了激进的高杠杆扩张策略，土地储备集中在三四线城市，项目去化率远低于行业平均水平。',
      },
      {
        type: 'heading',
        content: '债务结构深度剖析',
      },
      {
        type: 'paragraph',
        content: '根据获得的财务报表，这5家房企的债务结构呈现以下特点：短期债务占比过高（超过60%）、融资成本显著高于行业水平（平均超过8%）、经营性现金流持续为负、资产抵押率接近上限。这些指标综合表明，企业已基本丧失了通过常规渠道进行再融资的能力。',
      },
      {
        type: 'heading',
        content: '对购房者的影响',
      },
      {
        type: 'paragraph',
        content: '对于普通购房者而言，最直接的担忧是已购买但尚未交付的期房是否能够按时交付。根据初步统计，这5家房企在全国范围内的未交付房源超过15万套，涉及购房者超过40万人。一旦企业进入破产重整程序，购房者的权益保障将面临巨大不确定性。',
      },
      {
        type: 'paragraph',
        content: '51黑料网建议相关购房者密切关注项目进展，保留好购房合同和付款凭证，必要时可向当地住建部门反映情况。',
      },
    ],
  },

  'live-stream-fraud': {
    id: 6,
    title: '直播带货数据造假产业链：刷单、刷量、刷评论一条龙服务',
    slug: 'live-stream-fraud',
    category: '丑闻曝光',
    categorySlug: 'scandal-expose',
    author: '51黑料网互联网调查组',
    date: '2026-06-26',
    views: 143200,
    image: 'https://readdy.ai/api/search-image?query=Dark%20studio%20with%20phone%20screens%20glowing%20in%20amber%20light%2C%20moody%20cinematic%20atmosphere%2C%20social%20media%20theme%2C%20deep%20charcoal%20tones%2C%20investigative%20journalism%20style&width=1200&height=675&seq=article-detail-06&orientation=landscape',
    excerpt: '暗访记者卧底某刷单工作室，揭秘直播带货行业令人震惊的数据造假产业，知名主播也不能幸免。',
    hot: true,
    tags: ['直播带货', '数据造假', '刷单', '消费者权益'],
    sections: [
      {
        type: 'heading',
        content: '卧底刷单工作室',
      },
      {
        type: 'paragraph',
        content: '2026年5月，51黑料网记者以"兼职刷手"的身份，成功进入了一家位于某二线城市的刷单工作室。这家外表普通的写字楼里，摆放着超过200台手机，每一台手机都在自动执行着点赞、评论、下单等操作。这就是直播带货行业中鲜为人知的"数据工厂"。',
      },
      {
        type: 'heading',
        content: '完整的造假产业链',
      },
      {
        type: 'paragraph',
        content: '调查发现，直播带货数据造假已经形成了一条完整的产业链：上游是提供技术支持的脚本开发者，中游是操作数百台设备执行刷量任务的数据工厂，下游是购买造假服务的MCN机构和主播本人。',
      },
      {
        type: 'paragraph',
        content: '最令人震惊的是，多位拥有千万级粉丝的头部主播也被发现购买了此类服务。一位业内人士透露："不做数据的直播间几乎没有，区别只在于做多大规模。"',
      },
      {
        type: 'heading',
        content: '品牌方与消费者的双重受害',
      },
      {
        type: 'paragraph',
        content: '数据造假的最大受害者是品牌方和消费者。品牌方支付了高额的坑位费和佣金，换来的却是虚假的流量和大量退货订单。消费者则被虚假的"热销"氛围误导，购买了实际上并不受欢迎的商品。',
      },
    ],
  },

  'unicorn-finance-fraud': {
    id: 7,
    title: '某共享经济独角兽企业财务造假，估值虚高十倍以上',
    slug: 'unicorn-finance-fraud',
    category: '财经黑幕',
    categorySlug: 'finance',
    author: '51黑料网财经调查组',
    date: '2026-06-23',
    views: 178900,
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20tech%20office%20with%20glowing%20screens%20in%20dim%20amber%20light%2C%20moody%20cinematic%20composition%2C%20startup%20investigation%20theme%2C%20deep%20charcoal%20tones&width=1200&height=675&seq=article-detail-07&orientation=landscape',
    excerpt: '一份从内部流出的审计报告草稿显示，该独角兽企业的实际营收仅为其对外公布数据的十分之一，大量订单为虚构。',
    hot: true,
    tags: ['共享经济', '财务造假', '独角兽', '估值泡沫'],
    sections: [
      {
        type: 'heading',
        content: '审计报告揭示的惊天谎言',
      },
      {
        type: 'paragraph',
        content: '2026年6月，一份标注为"内部审计草案"的文件从某共享经济独角兽企业内部流出。该草案显示，这家估值超过50亿美元的明星企业的实际经营状况与其对外宣传存在巨大出入——真实营收不足对外公布数字的十分之一。',
      },
      {
        type: 'heading',
        content: '虚构订单的套路',
      },
      {
        type: 'paragraph',
        content: '根据审计报告，该公司通过自建团队大量生成虚构订单，利用虚假用户账户完成交易闭环。仅2025年度，虚构订单就占到了总订单量的65%以上。这些虚假数据被包装成漂亮的增长曲线，用于吸引新一轮融资。',
      },
      {
        type: 'paragraph',
        content: '目前，已有多家投资机构向该公司发出问询函，要求对审计报告内容做出解释。部分地区市场监管部门也已介入调查虚假交易的问题。',
      },
    ],
  },

  'insurance-claim-scandal': {
    id: 8,
    title: '保险行业理赔黑幕：故意拖延、无理拒赔的套路全面曝光',
    slug: 'insurance-claim-scandal',
    category: '独家黑料',
    categorySlug: 'exclusive',
    author: '51黑料网金融调查组',
    date: '2026-06-25',
    views: 95600,
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20insurance%20theme%20with%20torn%20documents%20in%20dramatic%20lighting%2C%20moody%20cinematic%20composition%2C%20deep%20charcoal%20tones%20with%20crimson%20and%20amber%20accents&width=1200&height=675&seq=article-detail-08&orientation=landscape',
    excerpt: '数百份内部培训资料显示，多家保险公司存在系统性的理赔拖延策略，专门针对普通消费者设置障碍。',
    hot: false,
    tags: ['保险', '理赔', '消费者权益', '行业黑幕'],
    sections: [
      {
        type: 'heading',
        content: '内部培训资料曝光',
      },
      {
        type: 'paragraph',
        content: '51黑料网获得了来自多家保险公司的内部培训资料，这些资料详细记录了面向理赔人员的"技巧培训"——核心内容竟然是如何"合法地"拖延理赔、降低赔付金额和寻找拒赔理由。',
      },
      {
        type: 'heading',
        content: '五大拒赔策略',
      },
      {
        type: 'list',
        items: [
          '要求补充材料：反复要求投保人提供非必要的证明材料，消耗其时间和精力',
          '条款解释陷阱：利用合同条款中的模糊表述，做出对投保人不利的解释',
          '拖延战术：对符合理赔条件的案件故意延长审核周期',
          '小额施压：先提出远低于应赔金额的和解方案，试探投保人底线',
          '区分对待策略：对聘请律师的投保人快速处理，对普通消费者则百般刁难',
        ],
      },
      {
        type: 'paragraph',
        content: '金融监管部门已注意到此问题，目前正在对多家保险公司的理赔数据进行专项检查。',
      },
    ],
  },

  'exam-cheating-scandal': {
    id: 9,
    title: '某省高考舞弊案细节披露：监考老师与考生内外勾结',
    slug: 'exam-cheating-scandal',
    category: '丑闻曝光',
    categorySlug: 'scandal-expose',
    author: '51黑料网教育调查组',
    date: '2026-06-24',
    views: 211500,
    image: 'https://readdy.ai/api/search-image?query=Dark%20empty%20examination%20hall%20with%20single%20desk%20illuminated%2C%20dramatic%20noir%20lighting%2C%20cinematic%20atmosphere%2C%20deep%20charcoal%20tones%20with%20subtle%20amber%20highlights&width=1200&height=675&seq=article-detail-09&orientation=landscape',
    excerpt: '2026年高考期间，某省多个考点被曝存在有组织的舞弊行为，涉及监考人员、教育系统内部人员协同作案。',
    hot: true,
    tags: ['高考', '舞弊', '教育公平', '监考'],
    sections: [
      {
        type: 'heading',
        content: '举报信牵出舞弊网络',
      },
      {
        type: 'paragraph',
        content: '2026年高考结束后第三天，51黑料网收到了一封匿名举报信，详细描述了某省三个考点的舞弊操作流程。举报人自称是其中一名"望风人员"，因良心不安决定曝光此事。',
      },
      {
        type: 'heading',
        content: '舞弊手法的三种模式',
      },
      {
        type: 'paragraph',
        content: '调查发现，该舞弊网络采用了三种主要模式：一是监考老师故意在关键时间点"恰好"离开考场，为考生传递答案创造条件；二是考场信号屏蔽器被人为关闭部分时段；三是利用提前获得的试卷信息，在考前将答案传递给特定的考生群体。',
      },
      {
        type: 'paragraph',
        content: '目前，教育部已派出专项调查组进驻该省，相关考点的成绩已被暂时冻结。多名涉事人员已被警方控制。',
      },
    ],
  },

  'govt-official-probe': {
    id: 10,
    title: '某省会城市住建局原局长被查，涉案金额或高达2亿',
    slug: 'govt-official-probe',
    category: '政商关系',
    categorySlug: 'politics',
    author: '51黑料网政经调查组',
    date: '2026-06-29',
    views: 89200,
    image: 'https://readdy.ai/api/search-image?query=Dark%20government%20building%20silhouette%20with%20single%20illuminated%20window%2C%20moody%20night%20scene%2C%20cinematic%20noir%20lighting%2C%20investigative%20journalism%20theme%2C%20deep%20charcoal%20tones%20with%20warm%20amber%20accents&width=1200&height=675&seq=article-detail-10&orientation=landscape',
    excerpt: '据纪检监察部门消息，该局长在任职期间利用职务便利为多家房地产企业谋取利益，收受财物折合人民币约2亿元。',
    hot: true,
    tags: ['反腐', '住建局', '官商勾结', '房地产'],
    sections: [
      {
        type: 'heading',
        content: '调查启动',
      },
      {
        type: 'paragraph',
        content: '2026年6月，某省会城市纪委监委发布通报，市住房和城乡建设局原局长张某涉嫌严重违纪违法，目前正接受纪律审查和监察调查。据内部人士透露，初步查明其涉案金额可能高达2亿元。',
      },
      {
        type: 'heading',
        content: '涉案领域广泛',
      },
      {
        type: 'paragraph',
        content: '调查显示，张某的违纪违法行为主要集中在四个方面：一是在工程项目审批环节为特定企业开绿灯；二是在房地产预售许可发放中以权谋私；三是在保障房分配中存在利益输送；四是利用亲属账户转移和隐匿非法所得。',
      },
      {
        type: 'paragraph',
        content: '据悉，与张某存在利益关联的多家房地产企业也已被纳入调查范围。此案是该省近年来查处的涉案金额最大的单起职务犯罪案件。',
      },
    ],
  },

  'govt-procurement-scandal': {
    id: 11,
    title: '政府采购黑幕：某市数亿元智慧城市项目围标串标细节曝光',
    slug: 'govt-procurement-scandal',
    category: '政商关系',
    categorySlug: 'politics',
    author: '51黑料网政经调查组',
    date: '2026-06-22',
    views: 73400,
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20government%20procurement%20theme%20with%20document%20stacks%20and%20official%20seals%2C%20moody%20cinematic%20lighting%2C%20deep%20charcoal%20and%20amber%20tones&width=1200&height=675&seq=article-detail-11&orientation=landscape',
    excerpt: '一份招投标内部记录揭示了某市智慧城市项目的围标串标操作全过程，涉及多家科技企业和政府官员。',
    hot: false,
    tags: ['政府采购', '围标串标', '智慧城市', '招投标'],
    sections: [
      {
        type: 'heading',
        content: '招投标记录的异常',
      },
      {
        type: 'paragraph',
        content: '51黑料网获取了一份某市智慧城市项目的完整招投标记录。这份超过200页的文件显示，在总金额高达3.7亿元的采购项目中，存在多处明显的围标串标痕迹。',
      },
      {
        type: 'heading',
        content: '围标的典型特征',
      },
      {
        type: 'paragraph',
        content: '专业人士分析指出，该项目的招投标呈现出围标串标的六大典型特征：多家投标企业报价高度接近、技术方案存在大段雷同、投标保证金来自同一账户、中标企业与其他投标企业存在关联关系、评标专家打分呈现极端分化、中标价格与预算惊人接近。',
      },
      {
        type: 'paragraph',
        content: '目前，相关线索已移交至纪检监察部门。该项目的部分资金已被冻结，等待进一步调查结果。',
      },
    ],
  },

  'ecommerce-fake-promo': {
    id: 12,
    title: '知名电商平台虚假促销内幕：先涨价再打折的套路全揭秘',
    slug: 'ecommerce-fake-promo',
    category: '互联网圈',
    categorySlug: 'internet',
    author: '51黑料网互联网调查组',
    date: '2026-06-29',
    views: 67300,
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20ecommerce%20theme%20with%20shopping%20cart%20silhouette%20in%20shadow%2C%20dramatic%20low%20key%20lighting%2C%20crimson%20price%20tag%20glow%2C%20cinematic%20editorial%20style%2C%20deep%20charcoal%20background&width=1200&height=675&seq=article-detail-12&orientation=landscape',
    excerpt: '通过对数十万条商品价格历史数据的追踪分析，我们还原了电商平台"618大促"期间的涨价再打折套路。',
    hot: false,
    tags: ['电商平台', '虚假促销', '价格欺诈', '消费者权益'],
    sections: [
      {
        type: 'heading',
        content: '价格追踪数据揭示真相',
      },
      {
        type: 'paragraph',
        content: '51黑料网利用价格追踪工具，对2026年618购物节期间主流电商平台上超过10万件商品的价格变动进行了全程监控。结果显示，超过40%的"促销商品"在活动开始前一周进行了明显的价格上调，幅度从15%到200%不等。',
      },
      {
        type: 'heading',
        content: '最常见的五种套路',
      },
      {
        type: 'list',
        items: [
          '提前涨价：大促前一周悄悄提价，活动当天恢复原价并标注"五折"',
          '虚构原价：标注一个从未实际销售过的"建议零售价"作为折扣基准',
          '捆绑销售：将滞销商品与热门商品捆绑，制造"超值套餐"假象',
          '限时饥饿营销：显示"仅剩X件"的虚假库存信息诱导冲动消费',
          '好评返现操控评分：通过小额返现诱导消费者给五星好评，掩盖商品真实质量',
        ],
      },
      {
        type: 'paragraph',
        content: '市场监管总局已针对此类问题出台了《明码标价和禁止价格欺诈规定》实施细则，多个地方市场监管部门已对违规平台开出罚单。',
      },
    ],
  },

  'edtech-training-scandal': {
    id: 13,
    title: '教育行业乱象：多家培训机构涉嫌虚假宣传，学员退款无门',
    slug: 'edtech-training-scandal',
    category: '互联网圈',
    categorySlug: 'internet',
    author: '51黑料网教育调查组',
    date: '2026-06-29',
    views: 54100,
    image: 'https://readdy.ai/api/search-image?query=Dark%20empty%20classroom%20with%20single%20desk%20under%20spotlight%2C%20moody%20atmospheric%20lighting%2C%20cinematic%20noir%20composition%2C%20investigative%20theme%2C%20deep%20charcoal%20and%20amber%20tones&width=1200&height=675&seq=article-detail-13&orientation=landscape',
    excerpt: '数百名学员维权无果，多家在线教育机构被曝虚假宣传、教学质量堪忧、退款承诺形同虚设。',
    hot: false,
    tags: ['在线教育', '虚假宣传', '退款难', '培训乱象'],
    sections: [
      {
        type: 'heading',
        content: '维权群里的呼声',
      },
      {
        type: 'paragraph',
        content: '在多个维权群中，超过500名学员向51黑料网反映了相似的遭遇：支付了数千至数万元不等的培训费用后，实际课程质量与宣传严重不符，讲师资历被夸大甚至造假，所谓的"包就业"承诺从未兑现。',
      },
      {
        type: 'heading',
        content: '退款流程设障碍',
      },
      {
        type: 'paragraph',
        content: '调查发现，这些培训机构在合同中设置了层层障碍：退款需扣除高额手续费、仅退还剩余课程费用但计算方式极不合理、设置极短的退款申请时限、要求学员必须完成全部课程后才能申请退款等。许多学员在漫长的等待中最终选择放弃。',
      },
      {
        type: 'paragraph',
        content: '教育部门已约谈了多家被投诉机构，要求限期整改并妥善处理学员退费问题。',
      },
    ],
  },

  'beauty-treatment-scandal': {
    id: 14,
    title: '医疗美容行业惊天陷阱：非法注射物致数百人毁容',
    slug: 'beauty-treatment-scandal',
    category: '独家黑料',
    categorySlug: 'exclusive',
    author: '51黑料网健康调查组',
    date: '2026-06-28',
    views: 120600,
    image: 'https://readdy.ai/api/search-image?query=Dark%20medical%20theme%20abstract%20with%20silhouetted%20medical%20tools%2C%20dramatic%20low%20key%20lighting%2C%20crimson%20warning%20tone%2C%20cinematic%20atmosphere%2C%20deep%20charcoal%20background&width=1200&height=675&seq=article-detail-14&orientation=landscape',
    excerpt: '一种未经国家批准的注射填充物在多家医美机构被广泛使用，已导致超过200名消费者出现感染、组织坏死等严重后果。',
    hot: true,
    tags: ['医美', '非法注射物', '毁容', '医疗安全'],
    sections: [
      {
        type: 'heading',
        content: '受害者的血泪控诉',
      },
      {
        type: 'paragraph',
        content: '"我花了三万块钱想变美，结果差点毁容。"28岁的李女士在接受面部填充注射后，出现了严重的排异反应，面部大面积红肿溃烂。她只是200多名已知受害者中的一员。',
      },
      {
        type: 'heading',
        content: '非法产品的流通链',
      },
      {
        type: 'paragraph',
        content: '经调查，涉事的注射填充物是一种未获得国家药监局批准的产品，通过地下渠道流入多家医美机构。这些机构以"进口高端材料""明星同款"等话术吸引消费者，单次收费从5000元到5万元不等，而产品的实际成本不足百元。',
      },
      {
        type: 'paragraph',
        content: '卫健部门已对涉事医美机构展开专项检查，部分机构已被吊销医疗机构执业许可证。公安部门也已介入非法产品的溯源调查。',
      },
    ],
  },

  'auto-spec-scandal': {
    id: 15,
    title: '汽车行业减配黑幕：同一车型国内外配置差异触目惊心',
    slug: 'auto-spec-scandal',
    category: '内幕揭秘',
    categorySlug: 'insider-reveal',
    author: '51黑料网汽车调查组',
    date: '2026-06-28',
    views: 78500,
    image: 'https://readdy.ai/api/search-image?query=Dark%20automotive%20theme%20with%20car%20silhouette%20in%20shadow%2C%20dramatic%20garage%20lighting%2C%20cinematic%20noir%20style%2C%20investigative%20atmosphere%2C%20deep%20charcoal%20and%20amber%20tones&width=1200&height=675&seq=article-detail-15&orientation=landscape',
    excerpt: '通过对比国内外多个车型的配置清单，我们发现部分合资品牌在中国市场销售的车型在安全配置上存在明显的"双重标准"。',
    hot: false,
    tags: ['汽车', '减配', '安全配置', '消费者权益'],
    sections: [
      {
        type: 'heading',
        content: '配置对比触目惊心',
      },
      {
        type: 'paragraph',
        content: '调查组选取了8款在中国市场热销的合资品牌车型，逐一对比了其在中国市场与海外市场（欧洲/北美）同款车型的配置清单。结果发现，6款车型存在明显的安全配置减配现象。',
      },
      {
        type: 'heading',
        content: '减配重灾区',
      },
      {
        type: 'paragraph',
        content: '减配主要集中在被动安全领域：海外版标配的后排侧安全气囊在国内被取消、车身结构关键部位的高强度钢被替换为普通钢材、电子稳定程序的版本落后海外市场一个代际。更令人担忧的是，这些减配信息从未在销售过程中向消费者明确告知。',
      },
      {
        type: 'paragraph',
        content: '中国消费者协会已表示关注此事，并呼吁车企在中国市场提供与海外市场同等的安全配置。',
      },
    ],
  },

  'p2p-recovery-scandal': {
    id: 16,
    title: 'P2P清退后续：某平台回款率不足3%，数万出借人血本无归',
    slug: 'p2p-recovery-scandal',
    category: '财经黑幕',
    categorySlug: 'finance',
    author: '51黑料网金融调查组',
    date: '2026-06-21',
    views: 113600,
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20financial%20crisis%20theme%20with%20scattered%20banknotes%20in%20shadow%2C%20moody%20cinematic%20lighting%2C%20deep%20charcoal%20and%20crimson%20tones&width=1200&height=675&seq=article-detail-16&orientation=landscape',
    excerpt: '某知名P2P平台清退方案公布后，近十万出借人发现自己的本金几乎全部打了水漂，清退方案背后的资产转移疑云有待揭开。',
    hot: false,
    tags: ['P2P', '清退', '金融诈骗', '出借人'],
    sections: [
      {
        type: 'heading',
        content: '清退方案的冰冷数字',
      },
      {
        type: 'paragraph',
        content: '2026年6月，某曾估值超过百亿的P2P平台公布了最终清退方案。方案显示，平台剩余可分配资产仅约1.2亿元，而出借人待收总额高达42亿元，回款率不足3%。这意味着绝大多数出借人几乎血本无归。',
      },
      {
        type: 'heading',
        content: '资产转移疑云',
      },
      {
        type: 'paragraph',
        content: '多位出借人代表向51黑料网反映，该平台在清退公告发布前数月，存在大规模资产转移的嫌疑。包括将优质债权低价转让给关联公司、以明显不合理的价格处置抵押资产、高管及其亲属提前赎回大量本息等。目前，公安机关已对此立案侦查。',
      },
    ],
  },
};

export function getArticleBySlug(slug: string): ArticleContent | undefined {
  return articles[slug];
}

export function getRelatedArticles(slug: string, count: number = 3): ArticleContent[] {
  const current = articles[slug];
  if (!current) return [];
  return Object.values(articles)
    .filter((a) => a.slug !== slug && a.category === current.category)
    .slice(0, count);
}

export function getArticlesByCategory(categorySlug: string): ArticleContent[] {
  return Object.values(articles).filter((a) => a.categorySlug === categorySlug);
}